import React from 'react';
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const QuestionNavigator = ({ 
  questions, 
  currentQuestionIndex, 
  answers, 
  onNavigate, 
  disabled 
}) => {
  return (
    <Card className="p-4">
      <h3 className="font-medium mb-3">Question Navigator</h3>
      <div className="grid grid-cols-5 gap-2">
        {questions.map((_, index) => (
          <Button
            key={index}
            variant={answers[questions[index]?._id] ? "default" : "outline"}
            className={`h-10 w-10 p-0 ${
              currentQuestionIndex === index
                ? "ring-2 ring-offset-2 ring-primary"
                : ""
            }`}
            onClick={() => onNavigate(index)}
            disabled={disabled}
          >
            {index + 1}
          </Button>
        ))}
      </div>
    </Card>
  );
};

export default QuestionNavigator;
